<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm">
            <thead>
                <tr class="bg-info-light white-text">
                    <th :colspan="pricelist.ranges.length">
                        {{ pricelist.name[locale] }} {{ validityPeriod(pricelist) }}
                    </th>
                </tr>
                <tr class="table-hinnad">
                    <th v-for="(range, i) in pricelist.ranges" :key="i" class="text-center">
                        {{ range.min === 0 ? range.min + 1 : range.min }} - {{ range.max | valueOrDots }} {{ $t('days') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-for="(range, i) in pricelist.ranges" :key="i" class="p-1">
                        <app-price :range="range"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'AppPricelist',
    props: {
        pricelist: Object
    },
    computed: {
        ...mapGetters(['locale']),
    },
    methods: {
        validityPeriod(pricelist) {
            return `${this.addZero(pricelist.start[0])}.${this.addZero(pricelist.start[1])} - ${this.addZero(pricelist.end[0])}.${this.addZero(pricelist.end[1])}`;
        },
        addZero(num) {
            if(String(num).length === 1) {
                return `0${num}`;
            }
            return num;
        }
    }
};
</script>
